import { useState } from "react";
import { CloudUpload } from "lucide-react";
import { Button } from "@mui/material";
import {
  TARS_CHART_PUBLISH_ARIA_LABEL,
  TARS_CHART_PUBLISH_BUTTON_LABEL,
} from "../tars-constants";

interface TARSChartPublishToolbarProps {
  onPublish: () => Promise<void>;
  disabled?: boolean;
  buttonLabel?: string;
  ariaLabel?: string;
}

export default function TARSChartPublishToolbar({
  onPublish,
  disabled = false,
  buttonLabel = TARS_CHART_PUBLISH_BUTTON_LABEL,
  ariaLabel = TARS_CHART_PUBLISH_ARIA_LABEL,
}: TARSChartPublishToolbarProps) {
  const [busy, setBusy] = useState(false);

  const run = async () => {
    if (busy || disabled) return;
    setBusy(true);
    try {
      await onPublish();
    } catch (e) {
      console.error("Push chart failed", e);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button
      type="button"
      variant="outlined"
      size="small"
      disabled={busy || disabled}
      onClick={() => void run()}
      aria-label={ariaLabel}
      startIcon={<CloudUpload size={16} strokeWidth={2} aria-hidden />}
      sx={{ textTransform: "none" }}
    >
      {busy ? "Pushing…" : buttonLabel}
    </Button>
  );
}
